import { isEscapedInJson } from '@vpfa/utils';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { uniq } from 'lodash';

/**
 * White chars that are not printed
 */
const transformToHumanReadable: string[] = ['\r', '\n', '\t', '\b', '\f'];

/**
 * Checks wether chars in control value can be safely used in JSON (without escaping)
 */
export function jsonSafeCharsValidator(control: AbstractControl<string>): ValidationErrors | null {
  if (control.value === undefined || control.value === null || control.value === '') {
    return;
  }

  // use spread instead of `.sprit()` to split emojis correctly
  const chars = [...control.value];

  const unsafeChars = [];

  chars.forEach(char => {
    if (isEscapedInJson(char)) {
      if (transformToHumanReadable.includes(char)) {
        const humanReadableChar = JSON.stringify(char).replace(/"/g, '');
        unsafeChars.push(`<em>${humanReadableChar}</em>`);
      } else {
        unsafeChars.push(`<em>${char}</em>`);
      }
    }
  });

  return unsafeChars.length === 0 ? null : { unsafeJsonChars: { unsafeCharsList: uniq(unsafeChars).join(', ') } };
}
